<template>
  <div
    data-current="Tab 1"
    data-easing="ease"
    data-duration-in="300"
    data-duration-out="100"
    class="klienti-tabs w-tabs"
  >
    <div class="klienti-tabs w-tab-menu">
      <!-- 
      zakonentovaný podmienka videnia nových len pre admina
      <a
        v-for="(type, index) in Object.keys(clientsConfig)"
        :key="index"
        v-if="type !== 'new' || (type === 'new' && role === 'alex_admin')"
        class="tab-link-broker w-inline-block w-tab-link no-decoration"
        :class="[activeTab === type ? 'w--current' : '']"
        data-w-tab="Tab 1"
        @click="switchTabs(type)"
      >
        <div class="noselect">{{ cardLabelsDict[type] }} ({{ getClientsCountByType(type) }})</div>
      </a> -->
      <a
        v-for="(type, index) in Object.keys(clientsConfig)"
        :key="index"
        class="tab-link-broker w-inline-block w-tab-link no-decoration"
        :class="[activeTab === type ? 'w--current' : '']"
        data-w-tab="Tab 1"
        @click="switchTabs(type)"
      >
        <div class="noselect">{{ cardLabelsDict[type] }} ({{ getClientsCountByType(type) }})</div>
      </a>
    </div>
    <div class="tabs-content-3 w-tab-content">
      <div
        data-w-tab="Tab 1"
        data-w-id="155033eb-2d0e-aa7b-9a05-cefed74ed377"
        class="tab-pane-klienti w-tab-pane w--tab-active"
      >
        <div class="klienti-list">
          <component
            v-for="(client, index) in activeTabClients"
            :is="getClientComponent(client)"
            :key="client.id"
            :client="client"
          />
          <div class="text-center mb-2" v-if="loading">
            <v-progress-circular
            class="loading-spinner extrasmall"
              indeterminate
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegisteredKlientItem from "@/components/broker/KartaKlienti/RegisteredKlientItem.vue";
import NewKlientItem from "@/components/broker/KartaKlienti/NewKlientItem.vue";
import {mapGetters} from "vuex";

export default {
  name: "KlientiItemWrapper",
  components: {
    NewKlientItem,
    RegisteredKlientItem
  },
  computed: {
    ...mapGetters({
      clientsConfig: "clientState/getClientsConfigs",
      clientsByType: "clientState/getClientsByType",

      loading: "clientState/getClientsLoading",

      role: "userState/getRole",
    }),

    activeTabClients() {
      return this.clientsByType(this.activeTab);
    },

    getClientsCountByType() {
      return (type) =>
        this.$store.getters["clientState/getCountOfClientsByType"](type);
    },
  },
  created() {
    this.activeTab = this.defaultTab;
    this.emitTabInfo();
  },
  watch: {
    async activeTabClients(newClients) {
      await this.$nextTick();
      if (newClients.length === 0)
        return;

      if (newClients.length === 10) {
        this.$emit("pagination-check");
      }
    },
    clientsConfig(newConfigs) {
      const searchClientsType = "search";

      if (newConfigs.hasOwnProperty(searchClientsType)) {
        this.activeTab = searchClientsType;
      } else {
        this.activeTab = this.defaultTab;
      }

      this.emitTabInfo();
    },
  },
  data() {
    return {
      cardLabelsDict: {
        new: "Nový",
        missed: "Nedovolal",
        approval: "Rozpracovaný",
        waiting: "Čakačka",
        archived: "ARCHÍV",
        search: "Výsledky hľadania"
      },

      defaultTab: "new",
      activeTab: null,
    }
  },
  methods: {
    emitTabInfo() {
      this.$emit("select-tab", this.activeTab);
    },
    getClientComponent(client) {
      if (client.client_profile.client_flow_status) {
        return "RegisteredKlientItem";
      } else {
        return "NewKlientItem";
      }
    },
    switchTabs(key) {
      const searchClientsType = "search";
      if (this.activeTab === searchClientsType) {
        this.$store.commit("clientState/removeClientsByType", searchClientsType);
      }
      this.$emit("reset-pagination");
      this.activeTab = key;
      this.emitTabInfo();
    },
  },
};
</script>

<style scoped lang="scss">
.klienti-list {
  padding-bottom: 140px;
}

.text-center {
  padding-top: 30px;
}
</style>
